<!-- <ng-container *ngIf="listDivisas">
	<div *ngFor="let divisa of listDivisas">
		<div class="row form-group mx-auto mb-2">
			<div class="col-8">
				<h4 class="font-weight-bold">{{ divisa.nombre }}</h4>
			</div>
			<div class="col-4 text-center">
				<h4>
					<span class="fs-4 badge rounded-pill bg-primary text-light"> $ {{ divisa.valorClp | number : "1.2-2" : "es" }}</span>
				</h4>
			</div>
		</div>
	</div>
</ng-container> -->
<ng-container *ngIf="loadingDivisasValues$ | async">
	<div class="row">
		<span class="spinner spinner-primary spinner-xs"></span>
	</div>
</ng-container>
<div class="d-none d-lg-flex align-items-center ml-4">
	<div class="d-flex align-items-center mr-2" *ngFor="let divisa of listDivisas">
		<div *ngIf="!divisa.nombre.toLowerCase().includes('euro') || !hideEuro">
			<a href="#" class="btn btn-light-primary font-weight-bolder btn-sm ml-2" style="font-size: 11px !important; white-space: nowrap">{{ divisa.nombre === "Dolar Observado" ? "Dólar" : divisa.nombre }}: $ {{ divisa.valorClp | number : "1.2-2" : "es" }}</a>
		</div>
	</div>
</div>
